<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      双龙站<br>
站点介绍<br>
双龙站位于龙岗区龙岗大道与龙平东路交叉路口处，车站主体沿龙平东路呈东西走向布置，东接新塘围站，西接龙园站。双龙站是16号线与3号线的换乘站，车站色彩基调以白色调为主，以“游龙”为主题，局部运用黄色调搭配突显龙纹特色。车站为地上二层+地下二层结构，地面一、二层为站厅层，地下一层为夹层及商业区，地下二层为站台层，站台形式为岛式站台。车站设置有9个出入口，临近龙岗长途汽车站、深圳市龙岗中心学校，周边以居住、体育、绿化用地为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:19	23:00	3号线	2分15-20秒	4分30秒<br>
双龙	--	--	3号线	2分15-20秒	4分30秒<br>
大运	06:09	23:18	16号线	5分32秒	6分41秒<br>
田心	06:14	23:30	16号线	5分32秒	6分41秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	23:00	3号线	3分15秒	5分钟<br>
双龙	--	--	3号线	3分15秒	5分钟<br>
大运	06:19	23:18	16号线	5分50秒	6分钟-9分钟<br>
田心	06:20	23:30	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	00:00	3号线	3分15秒	5分钟<br>
双龙	--	--	3号线	3分15秒	5分钟<br>
大运	06:19	00:18	16号线	5分50秒	6分钟-9分钟<br>
田心	06:20	00:30	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道南侧（西）、怡龙枫景园、龙岗长途汽车客运站、翠竹村、颐景峰苑<br><br>
B出入口:<br>
龙岗大道南侧（东）、深圳市龙岗区龙岗中心学校、三和村、中和街<br><br>
C出入口:<br>
龙岗大道北侧（东）、龙平东路、深圳市龙岗区中心医院<br><br>
D出入口:<br>
龙岗大道北侧（西）、龙岗老街、平冈中学、富佳街<br><br>
E出入口:<br>
龙岗大道北侧（东）<br><br>
F出入口:<br>
龙岗大道北侧（东）<br><br>
G1出入口:<br>
龙岗大道北侧（西）<br><br>
G2出入口:<br>
龙岗大道北侧（西）<br><br>
H出入口:<br>
龙岗大道北侧（西）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 双龙地铁站①<br>
E25、M275、M280、M307、M308、351、810、811、M386、862、惠州208、M139、M239、M396、M497、马峦山公园假日专线3<br><br>
B出入口:<br>
公交站名： 双龙地铁站②③<br>
M165、M361、M195、M219、M276、E6、E7、E23、E33、E34、M277、M304、M305、M359、818、M230、M136、M266<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "sanhaoxian",
            title: "3号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>